<template>
    <v-card elevation="0" hover>
    <v-btn text @click="pushNewCapLog">New Log</v-btn>
    <v-card-title  primary-title><h5>{{formmatedDate}}</h5></v-card-title>
    <v-card-text  :ref="'blabla'" v-html="logContent" 
        contenteditable="true" 
        class="terminal" 
        @keyup="debouncedSaveNewCapLog();
                markEditing()"
    >   
    </v-card-text>
    <v-card-actions>
    </v-card-actions>
</v-card>
</template>

<script>
    import {newEventualLog, updateCapLog, saveNewEventualCapLog} from "../services/caplogsServices";
    import {mapState} from 'vuex'
    import * as _ from 'lodash'
    import { setInterval, clearInterval } from 'timers';

    export default {
        data : function(){
            return {
                idleInterval : null,
                idleSecondsCounter : 5,
                logContent : '',
                newLogDate : new Date()
            }
        },
        created : function(){
            this.debouncedSaveNewCapLog = _.debounce(this.saveNewCapLog,500)
            newEventualLog()
            this.detectIdle()
        },
        computed : {
        formmatedDate : function(){
            let d = this.newLogDate
            return d.getFullYear()  + "/" + (d.getMonth() + 1) + "/" + d.getDate() + " - " + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();            
        },
        ...mapState(['newEventualCapLog'])
        },
        watch : {
            newEventualCapLog : function(){
                console.log("new log - active now is: ", this.newEventualCapLog.id)
            },
            idleSecondsCounter : function(){
                this.newLogDate = new Date()
            }
        },
        methods : {
            saveNewCapLog(){
                console.log("Saving content: " + " for " + this.newEventualCapLog.id + " " + this.$refs['blabla'].innerHTML)
                if(!this.$refs['blabla'].innerHTML == '')
                saveNewEventualCapLog(this.$refs['blabla'].innerHTML)
                this.debouncedSaveNewCapLog = _.debounce(this.updateEventualCapLog,1000)                
            },
            updateEventualCapLog(id){
                if(this.newEventualCapLog && !this.newEventualCapLog.log == ''){
                    console.log("Updating (from now): " + this.newEventualCapLog.id + " " + this.newEventualCapLog.log)
                    updateCapLog(this.newEventualCapLog.id, this.$refs['blabla'].innerHTML);
                }
            },
            markEditing(){
                this.$store.dispatch("editing");
                this.idleSecondsCounter = -1
            },
            detectIdle(){
                    let vi = this
                    setInterval(function(){
                        vi.idleSecondsCounter = vi.idleSecondsCounter + 1
                        if(vi.idleSecondsCounter > 60){
                            console.log("Idle for 60 seconds detected. Flushing new caplog if available")
                            vi.pushNewCapLog()
                            vi.idleSecondsCounter = 0
                        }
                    },1000)
            },
            pushNewCapLog(){
                if(this.newEventualCapLog && !this.$refs['blabla'].innerHTML == ''){
                    console.log("Flushing new caplog due to idle."  + this.newEventualCapLog.id + ": " + this.$refs['blabla'].innerHTML)
                    this.$store.dispatch("pushNewEventualLogAfterIdle")
                    this.idleSecondsCounter = 0
                    newEventualLog()
                    this.debouncedSaveNewCapLog = _.debounce(this.saveNewCapLog,500)
                    this.$refs['blabla'].innerHTML = ''
                }else{
                    console.log("Nothign to push")
                }
            }
        }
    }
</script>

<style>
    .terminal {
        outline: 0px solid transparent;
    }
</style>

